import { createSelector } from 'reselect'

export const getGame = (state) => state.game
export const getLastSceneId = createSelector([getGame], (game) => game.lastSceneId)
export const isResizing = createSelector([getGame], (game) => game.resizing)
export const getLastTouchedTarget = createSelector([getGame], (game) => game.lastTouchedTarget)
export const isShowingSceneTransition = createSelector(
  [getGame],
  (game) => game.showingSceneTransition
)
export const isShowConsumeActive = createSelector([getGame], (game) => game.showConsumeWarning)
export const getAudiosPlaying = createSelector([getGame], (game) => game.audiosPlaying)
export const getChangingScene = createSelector([getGame], (game) => game.changingScene)
export const getAudioStatus = createSelector([getGame], (game) => game.audioDisabled)
export const getScreens = createSelector([getGame], (game) => game.screens)
export const getPopups = createSelector([getGame], (game) => game.popups)
export const isShowingLoginError = createSelector([getGame], (game) => game.showingLoginError)
export const getDevice = createSelector([getGame], (game) => game.device)
export const isPortable = createSelector([getDevice], (device) => {
  const deviceInfo = device.info.device
  return deviceInfo && (deviceInfo.type == 'tablet' || deviceInfo.type == 'mobile')
})

export const getStoryLine = (state) => state.storyLine
export const getCurrentScene = createSelector([getGame, getStoryLine], (game, storyLine) => {
  let scene = storyLine.scenes[game.currentSceneId]
  return scene
})
export const getModuleComponents = createSelector([getGame], (game) => game.components)
export const isShowingMedia = createSelector([getGame], (game) => game.currentMediaId !== null)
export const isShowingError = createSelector([getGame], (game) => Boolean(game.currentError))
export const getCurrentError = createSelector([getGame], (game) => game.currentError)
export const getPromptFullscreen = createSelector([getGame], (game) => game.promptFullscreen)
export const getCursorPosition = createSelector([getGame], (game) => game.cursorPosition)
